/* eslint-disable global-require */
/* eslint-disable no-underscore-dangle */

import { createStore } from 'redux';
import rootReducer from 'desktop/reducers';


const store = (function(devMode){
  if (devMode === 'production') {
    return createStore(rootReducer);
  } else {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    if(composeEnhancers && typeof composeEnhancers === "function"){
      return createStore(rootReducer, composeEnhancers());
    } else {
      return createStore(rootReducer);
    }
  }
})(process.env.NODE_ENV)

// if (module.hot) {
//   // Enable Webpack hot module replacement for reducers
//   module.hot.accept('epgReducer', () => {
//     const nextEpgReducer = require('epgReducer').default;
//     store.replaceReducer(nextEpgReducer);
//   });
// }

export default store;
